export enum ThumbnailType {
  REACTANGLE_XS = "rectanglexs",
  REACTANGLE_SM = "rectanglesm",
  REACTANGLE_MD = "rectanglemd",
  REACTANGLE_LG = "rectanglelg",
  REACTANGLE_XL = "rectanglexl",
  SQUARE_XS = "squarexs",
  SQUARE_SM = "squaresm",
  SQUARE_MD = "squaremd",
  SQUARE_LG = "squarelg",
  SQUARE_XL = "squarexl",
  // FIXME: waiting define from designer team
}

const ACCEPT_IMAGE_TYPES_LOWERCASE =
	".png, .jpg, .jpeg";
const ACCEPT_IMAGE_TYPES =
ACCEPT_IMAGE_TYPES_LOWERCASE + ", " + ACCEPT_IMAGE_TYPES_LOWERCASE.toUpperCase();

export {
	ACCEPT_IMAGE_TYPES
};